<!-- header for mobile -->
<app-task-process-page-header
  *ngIf="shouldShowHeader"
  [taskProcessContext]="engagementService.strategy.taskProcessContext"></app-task-process-page-header>

<ion-content
  [fullscreen]="ionContentShouldBeFullscreen"
  [scrollEvents]="true"
  (ionScrollEnd)="onScrollEnd()"
  class="alc-bg-white-mosaic">
  <div [hidden]="infiniteScrollEnabled" class="alc-infinite-scroll-placeholder"></div>
  <ion-infinite-scroll
    (ionInfinite)="loadNextTasksOrActions($event)"
    [disabled]="!infiniteScrollEnabled"
    position="top"
    threshold="1px">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <div #messagesContainer class="messages-container">
    <div *ngIf="noMoreMessages" class="no-older-message">{{ 'm/task-process/no-messages' | translate }}</div>
    <div
      *ngFor="let chunk of chunks.loadedChunks; first as isFirstChunk; last as isLastChunk"
      [ngClass]="{ 'not-yet-inserted': isFirstChunk && isInsertingChunk }"
      class="chunk">
      <ng-container *ngFor="let message of chunk; last as isLastMessage; index as index; trackBy: trackById">
        <ng-container *ngIf="message">
          <div *ngIf="message.dayIndicatorFormat" class="bubble-day-indicator">
            <span>{{ message.datetime | dateTimezone: message.dayIndicatorFormat }}</span>
          </div>
          <div class="message-and-tags-container-and-editor">
            <div class="message-and-tags-container">
              <app-message-in-task-process
                [message]="message"
                [taskProcessContext]="engagementService.strategy.taskProcessContext"
                [shouldScrollToTask]="isLastChunk && isLastMessage && !hasScrolledToProcessedTask"
                [isTaskProcessPageMessageList]="true"
                (scrolledToProcessedTask)="didScrollToProcessedTask()"
                (retrySending)="retrySendingAnswer($event)"></app-message-in-task-process>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <div *ngIf="chunks.chunkNeedsNewMessagesSeparator(chunk)" class="new-messages-separator-container">
        <div class="new-messages-separator">
          <div class="line"></div>
          <div class="text">{{ 'm/task-process/unread-messages-below' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- overlay arrows to scroll to message when it's out of screen -->
  <ion-button
    *ngIf="isProcesedMessageAboveViewport"
    (click)="engagementService.strategy.taskProcessContext.scrollToProcessedTask()"
    slot="fixed"
    fill="clear"
    class="scroll-up-to-processed-message-button">
    <ion-icon src="assets/img/arrow-up-circle.svg" slot="icon-only"></ion-icon>
  </ion-button>
  <ion-button
    *ngIf="isProcesedMessageBelowViewport"
    (click)="engagementService.strategy.taskProcessContext.scrollToProcessedTask()"
    slot="fixed"
    fill="clear"
    class="scroll-down-to-processed-message-button">
    <ion-icon src="assets/img/arrow-down-circle.svg" slot="icon-only"></ion-icon>
  </ion-button>
</ion-content>

<ion-footer>
  <div [hidden]="isExpanded" (click)="isExpanded = true" class="folded-editor">
    <div class="textarea-and-send-button">
      <textarea
        rows="1"
        disabled
        placeholder="{{ 'm/task-process/placeholder-see-answer' | translate }}"
        class="alc-editor-textarea"
        (click)="$event.stopPropagation()"></textarea>
      <ion-button disabled fill="clear" class="tpp-send-icon-button">
        <ion-icon slot="icon-only" name="send-sharp"></ion-icon>
      </ion-button>
      <div class="tpp-textual-send-buttons-container">
        <ion-button disabled>
          {{ 'm/task-process/send' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
  <div [hidden]="!isExpanded" class="expanded-editor">
    <div class="editor-and-send-buttons">
      <app-choose-template-flow
        [taskProcessContext]="engagementService.strategy.taskProcessContext"
        [templates]="templates"
        (tryToSearchConversation)="tryToSearchConversation($event)"
        (getTemplatesForAccount)="getTemplatesForAccount($event)">
      </app-choose-template-flow>

      <div>
        <!-- trick ion-toolbar into not setting padding-bottom to the bottom safe area (the corresponding rule is set with :last-child) -->
      </div>
    </div>
    <ion-button (click)="isExpanded = false" expand="full" fill="clear" class="fold-button">
      <ion-icon slot="icon-only" name="chevron-down"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
